import { Controller } from '@hotwired/stimulus'

export default class NavigationPageController extends Controller {
  static targets = [
    'next'
  ]

  static values = {
    id: String,
    name: String,
    position: Number,
    isValid: Boolean,
    isCompleted: Boolean,
    isCurrent: Boolean,
    nextText: String,
    skipText: String
  }

  modifierChanged ({ detail: { id, isRequired, options } }) {
    if (this.page.id === id) {
      if (Array.isArray(options) && options.length === 0 && isRequired === false) {
        this.nextTarget.textContent = this.skipTextValue
      } else if (isRequired === false) {
        this.nextTarget.textContent = this.nextTextValue
      }
    }
  }

  pageUpdated ({ detail: { id, isValid, isCompleted, isCurrent } }) {
    if (this.page.id === id) {
      this.isValidValue = isValid
      this.isCompletedValue = isCompleted
      this.isCurrentValue = isCurrent
    }
  }

  isValidValueChanged () {
    if (this.hasNextTarget) {
      this.nextTarget.disabled = !this.isValidValue
    }
  }

  isCurrentValueChanged () {
    if (this.isCurrentValue) {
      this.element.classList.remove('hidden')
    } else {
      this.element.classList.add('hidden')
    }
  }

  get page () {
    return {
      id: this.idValue,
      name: this.nameValue,
      position: this.positionValue,
      isValid: this.isValidValue,
      isCompleted: this.isCompletedValue,
      isCurrent: this.isCurrentValue
    }
  }
}
